/**
 * Extended - Represents extended metadata and status information.
 * Used to track model information, modification dates, status flags, and display styles.
 */
export class Extended {
  /** Model identifier */
  Model: string;

  /** Last modified date and time */
  LastModified: Date;

  /** Modified status */
  Modified: string;

  /** New status */
  New: string;

  /** Locked status */
  Locked: string;

  /** Display style identifier */
  DisplayStyle: string;

  /**
   * Creates a new Extended instance
   * @param data - Object containing extended properties
   */
  constructor(data: {
    Model: string;
    LastModified: Date;
    Modified: string;
    New: string;
    Locked: string;
    DisplayStyle: string;
  }) {
    this.Model = data.Model;
    this.LastModified = data.LastModified;
    this.Modified = data.Modified;
    this.New = data.New;
    this.Locked = data.Locked;
    this.DisplayStyle = data.DisplayStyle;
  }

  /**
   * Creates an Extended from a plain object (useful for deserialization)
   * @param obj - Plain object with extended data
   * @returns New Extended instance
   */
  static fromObject(obj: Partial<Extended>): Extended {
    let lastModified: Date;
    if (obj.LastModified instanceof Date) {
      lastModified = obj.LastModified;
    } else if (typeof obj.LastModified === "string") {
      lastModified = new Date(obj.LastModified);
    } else {
      lastModified = new Date();
    }

    return new Extended({
      Model: obj.Model ?? "",
      LastModified: lastModified,
      Modified: obj.Modified ?? "",
      New: obj.New ?? "",
      Locked: obj.Locked ?? "",
      DisplayStyle: obj.DisplayStyle ?? "",
    });
  }

  /**
   * Converts the Extended to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      Model: this.Model,
      LastModified: this.LastModified.toISOString(),
      Modified: this.Modified,
      New: this.New,
      Locked: this.Locked,
      DisplayStyle: this.DisplayStyle,
    };
  }
}


